import { SVGProps, memo } from 'react'

function Cross(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 37 37"
      width={props.width}
      height={props.height ?? props.width}
    >
      <path
        fill={props.fill}
        stroke="transparent"
        strokeMiterlimit="10"
        d="M18.5 36.5a18 18 0 1118-18 18.02 18.02 0 01-18 18zm0-14.947h0l4.178 4.177a2.159 2.159 0 103.053-3.053L21.554 18.5l4.178-4.179a2.16 2.16 0 00-3.053-3.056L18.5 15.447l-4.178-4.181a2.16 2.16 0 10-3.053 3.056l4.177 4.178-4.178 4.179a2.159 2.159 0 103.053 3.053l4.179-4.177z"
      />
    </svg>
  )
}

Cross.defaultProps = {
  width: 36,
  fill: '#006ba6'
}

export default memo(Cross)
